export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・改善計畫的記載內容會顯示於{toCompanyName}。\n・附加檔案僅會在{toCompanyName}顯示檔案名稱，不會共享檔案內容。',
    },
    chat: {
      card_title: '訊息',
      input_area_description: '改善計畫相關問題，可發送訊息至{toCompanyName}。',
      send_confirm: {
        modal_title: '訊息寄送確認',
        confirm_text: '是否要寄送此訊息？',
        confirm_text_near_by_check_box: '訊息已確認。',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: '訊息刪除確認',
        confirm_text: '是否要刪除此訊息？',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: '收發紀錄',
        send_status: {
          success: '已寄送',
          failure: '寄送失敗',
        },
      },
    },
  },
}
